import type { FaireProductEntity } from "../../entity_types/product";

export const p_2fu34s8v70: FaireProductEntity = {
  token: "p_2fu34s8v70",
  type: "product",
  name: "Lamare Habit Tracker Journal – Daily & Monthly Goal Planner",
  brandToken: "b_ebzv5q77kr",
  brandName: "Lamare",
  imageUrl:
    "https://cdn.faire.com/fastly/3f11aa945ad6a3fde4ba63ea9d3823af30a684843b1b896e2b9f146812b74186.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aceceb2f0abfecd60a545978e196251e590ce1e3f7f85bae218613091d211232.png",
    "https://cdn.faire.com/fastly/3fc5c73f97ae36eff4da3807ff549f4bd29624f81aeb2ae1daf7f954b66fe054.png",
    "https://cdn.faire.com/fastly/9e8a29a41c6be47a470c6a837f1e2db9055e6aea6dd37e325c3ad3ea1be2feba.png",
    "https://cdn.faire.com/fastly/7f7dfec481616736a9a111fdda592e146646a7043e5bb76d8138d1b6e2f00dfa.png",
    "https://cdn.faire.com/fastly/76b8c1cce99b73c3de281f01915314b137aad0a1277126b16da62358fb720e12.png",
    "https://cdn.faire.com/fastly/6f94d622cb357e8cac07e6f61915ea75dc87a6983ff839a48126cb37beae0eee.png",
    "https://cdn.faire.com/fastly/40ebd1e597ecd2e863896a5a96f09b9ba6cd7e4ce5ac0c8b8f9216e2f0e25fb1.jpeg",
    "https://cdn.faire.com/fastly/d6e7a6b1d417d98e1d641838a2883bd2af50989fe23a90545d517e311edca5ad.png",
    "https://cdn.faire.com/fastly/aebc4cf2cd9a16bd9e0a70215d5ad24ea9d25519ff27f7f5fcd479dacd39f64c.png",
    "https://cdn.faire.com/fastly/16797b39aad6b0f583d200df5840b024789b915cc84f5d6c9a886bc55cc0f656.png",
  ],
  priceDollars: 15.12,
  description:
    "Track your daily, weekly, and monthly habits in this stylish habit tracker calendar. Perfect for organizing and improving your habits!\n\n• Build Consistency: Track daily habits to stay committed and achieve your goals.\n\n• Visual Progress: Easily see your progress and stay motivated with clear visual tracking.\n\n• Improve Productivity: Focus on key habits that drive personal growth and success.\n\n• Boost Accountability: Hold yourself accountable by monitoring your habits regularly.\n\n• Personal Growth: Develop positive routines that lead to long-term success and well-being.\n\nFeatures:\n\n• Size: 10 x 7.8 inches\n• 12 monthly calendars - covers 1 year\n• New habit suggestions\n• Gold wire binding\n• Wall-hang option\n• Sturdy cover\n• 140 gsm paper - no bleed through\n• Color variations for each month\n\nIdeal as a habit tracker notepad, goal tracker, or daily habit tracker journal to keep you motivated and achieve your goals.",
  tags: [],
  msrpDollars: 24.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:15.171Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
